import { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { Colors } from "../../utils/colors";
import RectangleButton from "../Buttons/RectangleButton";
import { useCheckWebAppVersion } from "../../hooks/useCheckWebAppVersion";

// Mounted within App.tsx so it survives navigation between top-level routes.
// Not dismissable - stays until the user reloads and picks up the new version.
// Only shown on the /home creator route - marketing/landing pages don't need it.
export const UpdateWebAppBanner = () => {
  const updateAvailable = useCheckWebAppVersion();
  const { pathname } = useLocation();

  const refreshOnPress = useCallback(() => {
    window.location.reload();
  }, []);

  if (!updateAvailable || !pathname.startsWith("/home")) {
    return null;
  }

  return (
    <div
      className="AlignedRow"
      style={{
        position: "fixed",
        top: 20,
        left: "50%",
        transform: "translateX(-50%)",
        gap: 14,
        paddingBlock: 7,
        paddingInline: 14,
        backgroundColor: Colors.WHITE,
        border: `1px solid ${Colors.GRAY2}`,
        borderRadius: 12,
        boxShadow: "-3px 7px 25px 1px #0000004d",
        zIndex: 10000,
      }}
    >
      <span className="bodySmallMedium" style={{ whiteSpace: "nowrap" }}>
        Your current version is outdated. Refresh to make sure you have the
        latest changes.
      </span>
      <RectangleButton
        buttonLabel={
          <span style={{ color: Colors.WHITE, fontSize: 14 }}>Reload</span>
        }
        onPress={refreshOnPress}
        altColor={Colors.BLACK}
        altPaddingVert={10}
        altPaddingHorz={14}
        containerStyles={{ whiteSpace: "nowrap" }}
      />
    </div>
  );
};
